module.exports = __webpack_public_path__ + "img/home-intro-dark.35c014f3.png";